import { SET_BUTTON_LOADING } from '../actionTypes';

// eslint-disable-next-line import/prefer-default-export
export const setButtonLoading = (isLoading) => ({
  type: SET_BUTTON_LOADING,
  payload: { isLoading },
});
